export function isStringFalsyOrWhitespace(str) {
  return !str || str.trim().length < 1;
}
